module.exports = __webpack_public_path__ + "img/icon-xlsx-document.9e4f2ebe.svg";